export default "__VITE_ASSET__D4PEZj5i__"